import React, {useEffect, useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {Hub, Logger} from "@aws-amplify/core";
import {AuthService} from "./service/auth-service";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {Alert, Box, InputAdornment} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import {motion} from 'framer-motion';
import {ButtonWithEffects} from '../../components/ui/ButtonWithEffects';

const containerSx = { minHeight: '100vh', background: 'linear-gradient(135deg, #F8FAFC 0%, #E8EDF2 100%)' };
const imageSx = {
    backgroundImage: "url('images/auth/forgot.webp')",
    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center',
    position: 'relative',
    '&::before': {
        content: '""', position: 'absolute', inset: 0,
        background: 'linear-gradient(135deg, rgba(99,102,241,0.3) 0%, rgba(236,72,153,0.2) 100%)',
    },
};
const authBoxSx = {
    width: '100%', maxWidth: 440, p: 6,
    background: 'rgba(255,255,255,0.9)', borderRadius: 4,
    boxShadow: '0 20px 60px rgba(0,0,0,0.08)', backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.5)',
};

export function ResetPasswordStep1() {
    const logger = new Logger("ResetPasswordStep1");
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState("");
    const [email, setEmail] = useState('');

    useEffect(() => {
        const onHubCapsule = ({channel, payload}) => {
            if (channel === AuthService.CHANNEL && payload.event === AuthService.AUTH_EVENTS.PASSWORD_RESET) {
                if (!payload.success) setErrorMessage(payload.message);
                else history.push("/forgotpassword2");
            }
        };
        Hub.listen(AuthService.CHANNEL, onHubCapsule, 'MyListener');
        return () => Hub.remove(AuthService.CHANNEL, onHubCapsule);
    });

    const onFinish = (e) => { e.preventDefault(); AuthService.forgotPassword(email); };

    return (
        <Grid container component="main" sx={containerSx}>
            <Grid item xs={false} sm={4} md={7} sx={imageSx}/>
            <Grid item xs={12} sm={8} md={5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
                <motion.div initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} transition={{duration: 0.5}}>
                    <Box sx={authBoxSx}>
                        <Box sx={{ textAlign: 'center', mb: 4 }}>
                            <img src={window.location.origin + '/logos/logo-md.png'} style={{width: 160}} alt=""/>
                        </Box>
                        <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 600 }}>
                            Reset Password
                        </Typography>
                        <Typography variant="body2" align="center" sx={{ color: 'text.secondary', mb: 3 }}>
                            Enter your email and we'll send you a reset code
                        </Typography>
                        {errorMessage && (
                            <motion.div initial={{opacity: 0, y: -10}} animate={{opacity: 1, y: 0}}>
                                <Alert severity="error" sx={{mb: 2}}>{errorMessage}</Alert>
                            </motion.div>
                        )}
                        <form onSubmit={onFinish}>
                            <TextField variant="outlined" required fullWidth label="Email Address"
                                autoComplete="email" type="email" margin="normal"
                                onInput={e => setEmail(e.target.value)}
                                InputProps={{ startAdornment: <InputAdornment position="start"><EmailIcon color="primary"/></InputAdornment> }}
                            />
                            <ButtonWithEffects type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
                                Send Reset Code
                            </ButtonWithEffects>
                            <Box sx={{ textAlign: 'center' }}>
                                <Link to="/login" style={{ fontSize: '0.875rem' }}>Back to sign in</Link>
                            </Box>
                        </form>
                    </Box>
                </motion.div>
            </Grid>
        </Grid>
    );
}
